import { useState } from 'react'

import { useBoolean } from 'ahooks'
import { Button, Tooltip, Upload, UploadFile, UploadProps } from 'antd'
import { createStyles } from 'antd-style'

import {
  isFailed,
  isSuccessful,
  isUploading
} from '@eastcoal/common/components/UploadFile/hooks/useResult/uploadStatus'
import { GenericalRecord } from '@eastcoal/common/types/utilities'

import { ImportExcelButtonProps } from './interface'

const useStyles = createStyles(({ prefixCls }) => ({
  uploadFile: {
    [`&.${prefixCls}-upload-wrapper `]: {
      display: 'contents'
    }
  }
}))

export const ImportExcelButton = <T extends GenericalRecord>({
  api,
  onChange,
  requestParams = {},
  // 导入Button props
  children = '导入物资',
  ...buttonProps
}: ImportExcelButtonProps<T>) => {
  const { styles } = useStyles()
  const [error, setError] = useState<Error>()
  const [loading, toggleLoading] = useBoolean(false)

  const handleUploadChange = ({ file }: { file: UploadFile<T> }) => {
    if (isUploading(file.status)) {
      toggleLoading.setTrue()
    } else if (isSuccessful(file.status)) {
      toggleLoading.setFalse()
      onChange(file.response)
    } else if (isFailed(file.status)) {
      toggleLoading.setFalse()
      setError(file.error)
    } else {
      toggleLoading.setFalse()
    }
  }

  const customRequest: UploadProps['customRequest'] = async ({
    file,
    onError,
    onSuccess
  }) => {
    const formData = new FormData()
    formData.append('file', file)

    Object.keys(requestParams).forEach(key => {
      formData.append(key, requestParams[key])
    })

    try {
      const res = await api(formData, {
        silence: true
      })
      onSuccess?.(res)
    } catch (error: any) {
      onError?.(error)
    }
  }

  const beforeUpload = () => {
    setError(undefined)
    toggleLoading.setTrue()
    return true
  }

  return (
    <Upload
      accept='.xls,.xlsx'
      beforeUpload={beforeUpload}
      className={styles.uploadFile}
      customRequest={customRequest}
      showUploadList={false}
      onChange={handleUploadChange}
    >
      <Tooltip title={error?.message}>
        <Button
          block
          danger={error ? true : false}
          loading={loading}
          {...buttonProps}
        >
          {children}
        </Button>
      </Tooltip>
    </Upload>
  )
}
